import axios from "../../common/utils/axios";

class BaseService {

    constructor(repo) {
        this.repo = repo
        this.axios = axios;
    }

    get(data) {
        return this.repo.get(data)
    }

    all(data) {
        return this.repo.all(data);
    }

    create(data, params = {}) {
        if(params.loader == undefined) params.loader = true
        return this.repo.create(data, params);
    }

    edit(data) {
        return this.repo.edit(data);
    }

    delete(data) {
        return this.repo.delete(data);
    }

    delete1(data) {
        return this.repo.delete1(data);
    }

    findById(data) {
        return this.repo.findById(data);
    }

}

export default BaseService;